export const REDUCER_KEY = 'flights';
